import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import jobsService from "../../../api/jobsService";
import {
  getJobsbyStateAndCityData,
  getPublicJobDetail,
} from "../../../redux/slices/jobsSlice";
import { Copy, Send, Users } from "lucide-react";
import { useLocation } from "react-router-dom";
import Select from "react-select";

import { Button, Card, Col, Collapse, Modal, Row } from "react-bootstrap";
import { ReactComponent as CrimeIcon } from "../../../assets/images/shild.svg";
import { ReactComponent as HospitalsIcon } from "../../../assets/images/hospital-orange.svg";
import { ReactComponent as HomePriceIcon } from "../../../assets/images/home-trend.svg";
import { ReactComponent as CalculatorIcon } from "../../../assets/images/mortage-calculator.svg";
import { ReactComponent as MoneyIcon } from "../../../assets/images/money.svg";
import { ReactComponent as ChevronRightIcon } from "../../../assets/images/btn-right-aero.svg";
import { ReactComponent as MapPin } from "../../../assets/images/location-detail.svg";

import { toast } from "sonner";
import CreatePostModal from "../../../pages/community/components/create-post-modal/CreatePostModal";
import useCategories from "../../../pages/community/hooks/useCategories";
import usePosts from "../../../pages/community/hooks/usePosts";
import "../../../pages/jobs/components/JobCard/jobdetail.scss";
import "../../../pages/jobs/components/JobCard/jobDetailCityHeader.scss";
import "../../../pages/search/cityDetailNew.scss";
import "./jobDetail.scss";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaWhatsapp,
  FaXTwitter,
} from "react-icons/fa6";
import { Line, Pie, Doughnut } from "react-chartjs-2";
import { FiArrowLeft, FiChevronDown, FiChevronUp, FiMapPin, FiStar } from "react-icons/fi";
import {
  getPublicSchoolData,
} from "../../../redux/slices/searchSlice";
import Jobcards from "../../../pages/search/jobcard";
import { useTheme } from "../../../context/ThemeContext";
const JobDetail = () => {
  const { resolvedTheme } = useTheme();
  const isDarkMode = resolvedTheme === "dark";
  const chartTextColor = isDarkMode ? "#9aa7ac" : "#656e74";
  const StarIcon = () => <FiStar />;
  const [isJobsExpanded, setIsJobsExpanded] = useState(true);
  const [isLicenseReqExpanded, setIsLicenseReqExpanded] = useState(true);
  const [isCeusExpanded, setIsCeusExpanded] = useState(true);
  const [isSpecialReqExpanded, setIsSpecialReqExpanded] = useState(true);
  const [isCompactStateExpanded, setIsCompactStateExpanded] = useState(true);
  const [isImportantConsiderationsExpanded, setIsImportantConsiderationsExpanded] = useState(true);

  //   const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();

  const { slug } = useParams();
  const id = slug?.split("-").pop();
  const [jobs, setjobs] = useState([]);

  const [jobsLoading, setJobsLoading] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [showCreatePostModal, setShowCreatePostModal] = useState(false);
  const [preFilledContent, setPreFilledContent] = useState("");
  const [jobListingCategory, setJobListingCategory] = useState(null);
  const token = useSelector((state) => state.auth.token);

  const { categories, loading: categoriesLoading } = useCategories();
  const { createPost } = usePosts();
  const { PublicJobDetail, isLoading } = useSelector(
    (state) => state.jobResults,
  );
  const [activePlan, setActivePlan] = useState("For Sale");
  const [selectedPlan, setSelectedPlan] = useState("For Sale");
  const [distance, setDistance] = useState(10);
  const schoolsResultsStore = useSelector(
    (state) => state.search.PublicSchoolData || [],
  );
  const [address, setAddress] = useState();
  const [showModal, setShowModal] = useState(false);

  const city = PublicJobDetail?.city_details?.city_details?.city;
  const state = PublicJobDetail?.city_details?.city_details?.state;
  const hasJobMeta = Boolean(
    PublicJobDetail?.promoted_by || PublicJobDetail?.source_name,
  );
  const navigate = useNavigate();
  const [selectedLevel, setSelectedLevel] = useState({
    value: "Elementary",
    label: "Elementary",
  });
  const { schoolsLoading } = useSelector((state) => state.search);
  const SchoolDetails = useSelector(
    (state) => state.jobResults.PublicJobDetail?.city_details?.city_details,
  );
  const formatSalary = (salary) => {
    if (!salary || (!salary.min && !salary.max)) {
      return "Salary not listed";
    }

    const min = salary.min ? Number(salary.min).toLocaleString() : null;

    const max = salary.max ? Number(salary.max).toLocaleString() : null;

    if (min && max) {
      return `$${min} - $${max}`;
    }

    if (min) {
      return `From $${min}`;
    }

    if (max) {
      return `Up to $${max}`;
    }

    return "Compensation not disclosed";
  };

  const formatbonus = (bonus) => {
    if (!bonus) {
      return "Not listed";
    }

    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      currencyDisplay: "symbol",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(bonus);
  };
  const formatCompactPrice = (value) => {
    if (!value) return "0";
    const number = Number(value);
    if (number >= 1000000) return `${(number / 1000000).toFixed(number % 1000000 === 0 ? 0 : 1)}M`;
    if (number >= 1000) return `${(number / 1000).toFixed(number % 1000 === 0 ? 0 : 1)}K`;
    return number.toString();
  };

  const createSlug = (text = "") => {
    return text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");
  };
  const buildJobSeoUrl = () => {
    if (!PublicJobDetail) return "#";

    const titleSlug = createSlug(PublicJobDetail?.title);
    const slug = titleSlug
      ? `${titleSlug}-${PublicJobDetail?.id}`
      : `${PublicJobDetail?.id}`;

    return `${window.location.origin}/job-detail/${slug}`;
  };

  const generateJobPostContent = useCallback(() => {
    const jobTitle = PublicJobDetail?.title || "Job Opportunity";
    const companyName = PublicJobDetail?.company?.name || "Company";
    const salary = formatSalary(PublicJobDetail?.salary);

    const location =
      PublicJobDetail?.location?.city && PublicJobDetail?.location?.state
        ? `${PublicJobDetail.location.city}, ${PublicJobDetail.location.state}`
        : "Location not specified";

    const applicationUrl = PublicJobDetail?.application_url || "";
    const websiteUrl = `${window.location.origin}/jobs`;

    let content = ` Job Opportunity: ${jobTitle}\n\n`;
    content += ` Company: ${companyName}\n`;
    content += ` Salary: ${salary}\n`;
    content += ` Location: ${location}\n`;

    if (PublicJobDetail?.work_model) {
      content += ` Work Mode: ${PublicJobDetail.work_model}\n`;
    }

    if (PublicJobDetail?.job_type) {
      content += ` Job Type: ${PublicJobDetail.job_type}\n`;
    }

    if (PublicJobDetail?.shift_type) {
      content += ` Shift: ${PublicJobDetail.shift_type}\n`;
    }

    if (PublicJobDetail?.description) {
      content += `\n Description:\n${PublicJobDetail.description}\n`;
    }

    if (applicationUrl) {
      content += `\nApply here: ${applicationUrl}\n`;
    }

    return content;
  }, [PublicJobDetail]);

  const timeAgo = (date) => {
    if (!date) return "";

    const now = Date.now();
    const past = new Date(date).getTime();
    const diffMs = now - past;

    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (seconds < 60) return "Just now";

    if (minutes < 60) return minutes === 1 ? "1 min ago" : `${minutes} min ago`;

    if (hours < 24) return hours === 1 ? "1 hour ago" : `${hours} hours ago`;

    if (days >= 7 && days <= 28 && days % 7 === 0) {
      const weeks = days / 7;
      return weeks === 1 ? "1 week ago" : `${weeks} weeks ago`;
    }

    if (days < 30) return days === 1 ? "1 day ago" : `${days} days ago`;

    if (months < 12)
      return months === 1 ? "1 month ago" : `${months} months ago`;

    return years === 1 ? "1 year ago" : `${years} years ago`;
  };
  const getApplyUrl = (url) => {
    if (!url) return "#";

    if (/^https?:\/\//i.test(url)) {
      return url;
    }

    return `https://${url}`;
  };

  const handleShareClick = () => {
    setShareModal(true);
  };

  const closeShareModal = () => {
    setShareModal(false);
  };

  const shareToSocialMedia = (platform) => {
    const seoUrl = buildJobSeoUrl();

    if (!seoUrl || seoUrl === "#") {
      toast.error("Job link not available");
      return;
    }

    const jobTitle = PublicJobDetail?.title || "this job opportunity";
    const companyName = PublicJobDetail?.company?.name || "Company";

    const shareText = `Check out ${jobTitle} at ${companyName}`;

    let url = "";

    switch (platform) {
      case "twitter":
        url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
          shareText,
        )}&url=${encodeURIComponent(seoUrl)}`;
        break;

      case "facebook":
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          seoUrl,
        )}`;
        break;

      case "whatsapp":
        url = `https://wa.me/?text=${encodeURIComponent(
          shareText + " " + seoUrl,
        )}`;
        break;

      case "linkedin":
        url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          seoUrl,
        )}`;
        break;

      case "copy":
        navigator.clipboard
          .writeText(seoUrl)
          .then(() => toast.success("Link copied to clipboard!"))
          .catch(() => toast.error("Failed to copy link"));
        closeShareModal();
        return;

      default:
        return;
    }

    if (url) {
      window.open(
        url,
        "_blank",
        "width=600,height=400,scrollbars=yes,resizable=yes",
      );
      closeShareModal();
    }
  };

  const avatarColors = [
    // '0195D3',
    // '16A34A',
    // 'DC2626',
    // '7C3AED',
    // 'EA580C',
    // '0D9488',
    // 'CA8A04',
    "054473",
    "0195D3",
    "7c3aed",
  ];

  const getAvatarColor = (key) => {
    let hash = 0;
    const str = String(key || "Company");

    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    return avatarColors[Math.abs(hash) % avatarColors.length];
  };
  const avatarBg = getAvatarColor(
    PublicJobDetail?.id || PublicJobDetail?.company?.name,
  );

  useEffect(() => {
    if (!SchoolDetails?.state || !SchoolDetails?.city) return;

    const payload = {
      state: SchoolDetails.state,
      city: SchoolDetails.city,
      level_codes: selectedLevel.value,
    };

    dispatch(getPublicSchoolData(payload));
  }, [dispatch, selectedLevel, SchoolDetails?.state, SchoolDetails?.city]);
  useEffect(() => {
    if (categories && categories.length > 0) {
      const jobCategory = categories.find((cat) => cat.id === 9);
      if (jobCategory) {
        setJobListingCategory(jobCategory);
      }
    }
  }, [categories]);
  useEffect(() => {
    if (
      location.state?.action === "OPEN_JOB_SHARE" &&
      location.state?.jobId === PublicJobDetail?.id
    ) {
      const jobContent = generateJobPostContent();
      setPreFilledContent(jobContent);
      setShowCreatePostModal(true);

      navigate(location.pathname, { replace: true });
    }
  }, [
    location.state,
    PublicJobDetail,
    navigate,
    generateJobPostContent,
    location.pathname,
  ]);

  useEffect(() => {
    dispatch(getPublicJobDetail(id));
  }, [dispatch, id]);

  const formatPercent = (val) => {
    if (!val) return 0;
    const num = parseFloat(String(val).replace("%", ""));
    return isNaN(num) ? 0 : num;
  };
  const pieArray = useSelector(
    (state) => state.jobResults.PublicJobDetail?.city_details?.pie_data,
  );
  const chartPieData = React.useMemo(() => {
    if (!pieArray || !Array.isArray(pieArray) || pieArray.length === 0) {
      return { labels: [], datasets: [] };
    }

    const labels = pieArray.map((p) => p.name ?? p.label ?? p.text ?? "");

    const data = pieArray.map((p) => {
      if (typeof p.value === "number") return p.value;
      if (typeof p.val === "number") return p.val;
      if (typeof p.amount === "number") return p.amount;
      if (typeof p.text === "string")
        return Number(p.text.replace(/[^0-9.-]+/g, "")) || 0;
      return 0;
    });

    const defaultColors = [
      "#0195D3",
      "#0A4D7B",
      "#8CD7F7",
      "#BB63F7",
      "#FFB701",
    ];
    const backgroundColor = pieArray.map(
      (p, i) => p.color ?? defaultColors[i % defaultColors.length],
    );

    return {
      labels,
      datasets: [
        {
          data,
          backgroundColor,
          borderWidth: 0,
        },
      ],
    };
  }, [pieArray]);

  const distanceOptions = [
    { value: 5, label: "5 mi" },
    { value: 10, label: "10 mi" },
    { value: 15, label: "15 mi" },
    { value: 20, label: "20 mi" },
    { value: 30, label: "30 mi" },
    { value: 50, label: "50 mi" },
  ];

  const getRedfinZipUrl = (zip) => {
    if (!zip) return "https://www.redfin.com";
    return `https://www.redfin.com/zipcode/${zip}`;
  };

  const getZillowLink = async (address, radiusMiles, isRent = false) => {
    const query = address;
    const geoUrl = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(
      query,
    )}&format=json&limit=1`;

    try {
      const response = await fetch(geoUrl);
      const data = await response.json();

      if (data.length === 0) throw new Error("Location not found");

      const lat = parseFloat(data[0].lat);
      const lon = parseFloat(data[0].lon);

      const latOffset = radiusMiles / 69;
      const lonOffset = radiusMiles / (69 * Math.cos((lat * Math.PI) / 180));

      if (isRent) {
        const rentalSearchState = {
          pagination: {},
          mapBounds: {
            north: lat + latOffset,
            south: lat - latOffset,
            east: lon + lonOffset,
            west: lon - lonOffset,
          },
          isMapVisible: true,
          isListVisible: true,
          mapZoom: 11,
          regionSelection: [],
          filterState: {
            fr: { value: true },
            fsba: { value: false },
            fsbo: { value: false },
            nc: { value: false },
            cmsn: { value: false },
            auc: { value: false },
            fore: { value: false },
            sort: { value: "globalrelevance" },
          },
          isMapSearch: true,
        };

        const encodedState = encodeURIComponent(
          JSON.stringify(rentalSearchState),
        );
        const finalUrl = `https://www.zillow.com/homes/for_rent/?searchQueryState=${encodedState}`;
        console.log("Zillow Rentals Link:", finalUrl);
        return finalUrl;
      } else {
        const saleSearchState = {
          pagination: {},
          mapBounds: {
            north: lat + latOffset,
            south: lat - latOffset,
            east: lon + lonOffset,
            west: lon - lonOffset,
          },
          isMapVisible: true,
          isListVisible: true,
          mapZoom: 9,
          filterState: {
            isAllHomes: { value: true },
            sortSelection: { value: "globalrelevance" },
          },
        };

        const encodedState = encodeURIComponent(
          JSON.stringify(saleSearchState),
        );
        const finalUrl = `https://www.zillow.com/homes/for_sale/?searchQueryState=${encodedState}`;
        console.log("Zillow For Sale Link:", finalUrl);
        return finalUrl;
      }
    } catch (error) {
      console.error("Error generating Zillow link:", error);
      return null;
    }
  };

  const searchOnZillow = async () => {
    if (!address) return;

    const isRent = activePlan === "For Rent";

    const finalUrl = await getZillowLink(address, distance, isRent);

    if (finalUrl) {
      window.open(finalUrl, "_blank");
    }
  };

  const propertyData = {
    "For Sale": {
      cards: [
        {
          label: "Typical Home Value for the Region",
          value: PublicJobDetail?.city_details?.city_details?.home_prices
            ? `$${Number(
              PublicJobDetail.city_details.city_details.home_prices,
            ).toLocaleString("en-US")}`
            : "--",

          icon: <HomePriceIcon />,
        },
        {
          label: "Estimated mortgage",
          value: PublicJobDetail?.city_details?.city_details
            ?.annual_mortgage_payments
            ? `$${Number(
              (
                PublicJobDetail.city_details.city_details
                  .annual_mortgage_payments / 12
              ).toFixed(0),
            ).toLocaleString("en-US")}`
            : "--",
          suffix: "/month",
          icon: <CalculatorIcon />,
        },
        {
          label: "Leftover income",
          value: PublicJobDetail?.city_details?.city_details
            ?.left_over_annually_if_owning
            ? `$${Number(
              (
                PublicJobDetail.city_details.city_details
                  .left_over_annually_if_owning / 12
              ).toFixed(0),
            ).toLocaleString("en-US")}`
            : "--",

          suffix: "/month",
          icon: <MoneyIcon />,
        },
      ],
      buttons: {
        redfin: {
          label: "View homes for sale on Redfin",
          link: getRedfinZipUrl(PublicJobDetail?.city_details?.zip),
        },
        zillow: {
          label: "View homes for sale on Zillow",
        },
      },
    },

    "For Rent": {
      cards: [
        {
          label: "Median rent",
          value: PublicJobDetail?.city_details?.city_details
            ?.average_monthly_rent_prices
            ? `$${Number(
              PublicJobDetail.city_details.city_details
                .average_monthly_rent_prices,
            ).toLocaleString("en-US", {
              maximumFractionDigits: 0,
            })}`
            : "--",

          suffix: "/month",
          icon: <HomePriceIcon />,
        },
        {
          label: "Estimated utilities",
          value: PublicJobDetail?.city_details?.city_details?.annual_taxes_paid
            ? `$${Number(
              (
                PublicJobDetail.city_details.city_details.annual_taxes_paid /
                12
              ).toFixed(0),
            ).toLocaleString("en-US")}`
            : "--",
          suffix: "/month",
          icon: <CalculatorIcon />,
        },
        {
          label: "Leftover income",
          value: PublicJobDetail?.city_details?.city_details
            ?.left_over_annually_if_renting
            ? `$${Number(
              (
                PublicJobDetail.city_details.city_details
                  .left_over_annually_if_renting / 12
              ).toFixed(0),
            ).toLocaleString("en-US")}`
            : "--",
          suffix: "/month",
          icon: <MoneyIcon />,
        },
      ],
      buttons: {
        redfin: {
          label: "View rentals on Redfin",
          link:
            getRedfinZipUrl(PublicJobDetail?.city_details?.zip) + "/rentals",
        },
        zillow: {
          label: "View rentals on Zillow",
        },
      },
    },
  };
  const currentData = propertyData[activePlan];

  function getblueShades(percent) {
    percent = Math.max(0, Math.min(percent, 100));

    // Apply 5% stepping for clear visible color shifts
    const stepped = Math.round(percent / 5) * 5;

    // Lightest shade (0%) — softened version of #8CD7F7
    const start = { r: 210, g: 245, b: 255 };

    // Darkest shade (100%) — #8CD7F7
    const end = { r: 140, g: 215, b: 247 };

    const r = Math.round(start.r + (end.r - start.r) * (stepped / 100));
    const g = Math.round(start.g + (end.g - start.g) * (stepped / 100));
    const b = Math.round(start.b + (end.b - start.b) * (stepped / 100));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function getPurpleShade(percent) {
    percent = Math.max(0, Math.min(percent, 100));

    // Apply 5% stepping (stronger visible color changes)
    const stepped = Math.round(percent / 5) * 5;

    // Lightest shade (0%)
    const start = { r: 245, g: 220, b: 255 };

    // Darkest shade #8600FF (100%)
    const end = { r: 134, g: 0, b: 255 };

    const r = Math.round(start.r + (end.r - start.r) * (stepped / 100));
    const g = Math.round(start.g + (end.g - start.g) * (stepped / 100));
    const b = Math.round(start.b + (end.b - start.b) * (stepped / 100));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function getRedShade(percent) {
    percent = Math.max(0, Math.min(percent, 100));

    // Apply 5% stepping for stronger visible color jumps
    const stepped = Math.round(percent / 5) * 5;

    // Lightest shade (0%)
    const start = { r: 255, g: 230, b: 230 };

    // Darkest shade (100%) — #FF0000
    const end = { r: 255, g: 0, b: 0 };

    const r = Math.round(start.r + (end.r - start.r) * (stepped / 100));
    const g = Math.round(start.g + (end.g - start.g) * (stepped / 100));
    const b = Math.round(start.b + (end.b - start.b) * (stepped / 100));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function getOrangeShade(percent) {
    percent = Math.max(0, Math.min(percent, 100));

    // Convert to nearest 5% step → makes color visibly change every 5%
    const stepped = Math.round(percent / 5) * 5;

    const start = { r: 255, g: 220, b: 180 };
    const end = { r: 255, g: 104, b: 0 };

    const r = Math.round(start.r + (end.r - start.r) * (stepped / 100));
    const g = Math.round(start.g + (end.g - start.g) * (stepped / 100));
    const b = Math.round(start.b + (end.b - start.b) * (stepped / 100));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function getCrimeShades(percent) {
    percent = Math.max(0, Math.min(percent, 100));

    const stepped = Math.round(percent / 5) * 5;

    // FILL COLOR (progress)
    const start = { r: 220, g: 248, b: 245 }; // very light
    const end = { r: 16, g: 185, b: 165 }; // strong teal

    const r = Math.round(start.r + (end.r - start.r) * (stepped / 100));
    const g = Math.round(start.g + (end.g - start.g) * (stepped / 100));
    const b = Math.round(start.b + (end.b - start.b) * (stepped / 100));

    return `rgb(${r}, ${g}, ${b})`;
  }
  function getCrimeBgShade() {
    return "rgb(160, 210, 205)";
  }

  function getGradePercentage(grade) {
    if (!grade) return null; // keep N/A behavior

    const map = {
      "A+": 100,
      A: 95,
      "A-": 90,
      "B+": 85,
      B: 80,
      "B-": 75,
      "C+": 70,
      C: 65,
      "C-": 60,
      "D+": 55,
      D: 50,
      "D-": 45,
      F: 30,
    };

    return map[grade] ?? 10; // 👈 fallback for unknown values
  }

  const grade =
    PublicJobDetail?.city_details?.city_details?.overall_crime_grade;

  const percent = getGradePercentage(grade);
  const violentGrade =
    PublicJobDetail?.city_details?.city_details?.violent_crime_grade;
  const violentPercent = getGradePercentage(violentGrade);
  const propertyGrade =
    PublicJobDetail?.city_details?.city_details?.property_crime_grade;
  const propertyPercent = getGradePercentage(propertyGrade);
  const otherGrade =
    PublicJobDetail?.city_details?.city_details?.other_crime_grade;
  const otherPercent = getGradePercentage(otherGrade);

  const handleSchoolClick = (school) => {
    const website = (school?.website || "").trim();

    const hasWebsite = website.length > 0;
    const validWebsite =
      hasWebsite && !website.startsWith("http")
        ? `https://${website}`
        : hasWebsite
          ? website
          : null;

    const allWebsites =
      schoolsResultsStore?.length > 0
        ? schoolsResultsStore.map((s) => s.website)
        : null;

    if (validWebsite) {
      window.open(validWebsite, "_blank", "noopener,noreferrer");
    } else {
      setTimeout(() => setShowModal(true), 0);
    }
  };

  const temperatureData = PublicJobDetail?.city_details?.temperature_data;
  const monthLabels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const highTemps = monthLabels.map((m) => {
    const raw =
      temperatureData?.[`High_${m}`] ?? temperatureData?.[`High ${m}`] ?? null;
    if (raw === null || raw === undefined) return null;
    const n = Number(String(raw).replace(/[^0-9.-]+/g, ""));
    return isNaN(n) ? null : n;
  });

  const lowTemps = monthLabels.map((m) => {
    const raw =
      temperatureData?.[`Low_${m}`] ?? temperatureData?.[`Low ${m}`] ?? null;
    if (raw === null || raw === undefined) return null;
    const n = Number(String(raw).replace(/[^0-9.-]+/g, ""));
    return isNaN(n) ? null : n;
  });

  const lineData = {
    labels: monthLabels,
    datasets: [
      {
        label: "High",
        data: highTemps,
        borderColor: "#ff6b6b",
        backgroundColor: "rgba(255,107,107,0.2)",
        tension: 0.35,
      },
      {
        label: "Low",
        data: lowTemps,
        borderColor: "#4dabf7",
        backgroundColor: "rgba(77,171,247,0.2)",
        tension: 0.35,
      },
    ],
  };

  const isLargeScreen =
    typeof window !== "undefined" && window.innerWidth >= 1200;
  const lineOptions = {
    responsive: true,
    maintainAspectRatio: false, // let the container control the height to avoid CSS scaling blur
    plugins: {
      legend: { position: "bottom", labels: { color: chartTextColor } },
      title: { display: false },
    },
    elements: {
      line: { borderWidth: 2 },
      point: { radius: 2, hitRadius: 8, hoverRadius: 4 },
    },
    scales: {
      x: {
        ticks: { autoSkip: true, maxRotation: 0, color: chartTextColor },
        grid: { display: false },
      },
      y: {
        ticks: {
          callback: (v) => `${v}°`,
          padding: isLargeScreen ? 12 : 6,
          maxTicksLimit: isLargeScreen ? 10 : 6,
          color: chartTextColor,
        },
        grid: { display: false },
      },
    },
  };

  useEffect(() => {
    const getJobs = async () => {
      if (!city || !state) return;

      setJobsLoading(true);
      try {
        const result = await dispatch(
          getJobsbyStateAndCityData({ city, state }),
        );
        setjobs(result.payload?.data.data || []);
        console.log(result, "jobs result");
      } catch (error) {
        console.error("Failed to fetch jobs:", error);
      } finally {
        setJobsLoading(false);
      }
    };

    getJobs();
  }, [dispatch, city, state]);
  if (isLoading) {
    return (
      <div className="public-job-detail-wrapper vh-100 d-flex justify-content-center align-items-center">
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status" />
          <h5>Loading Job data...</h5>
        </div>
      </div>
    );
  }

  if (!isLoading && !PublicJobDetail) {
    return (
      <div className="public-job-detail-wrapper vh-100 d-flex justify-content-center align-items-center">
        <div className="text-center">
          <h4 className="mb-2">No Job Found</h4>
          <p className="text-muted">
            The job you're looking for does not exist.
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="job-details-page public-job-details-page">
        <div className="app-page-title">
          <div className="page-title-heading d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              {/* <FiArrowLeft
                size={40}
                className="icon cursor-pointer"
                onClick={() => navigate("/jobs")}
              /> */}
              <h3 className="page-title">Job Detail</h3>
            </div>
            <div
              className="d-flex align-items-center gap-3 page-title-actions-mobile-only"
              style={{ marginRight: "8px" }}
            >
              <Button
                variant="link"
                size="sm"
                onClick={handleShareClick}
                className="p-0 d-flex align-items-center justify-content-center text-muted"
                style={{
                  border: "1px solid var(--mmp-border)",
                  borderRadius: "8px",
                  backgroundColor: "var(--mmp-surface)",
                  width: "40px",
                  height: "40px",
                  minWidth: "40px",
                  transition: "all 0.2s ease",
                  padding: "0 !important",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "var(--mmp-hover-bg)";
                  e.currentTarget.style.borderColor = "var(--mmp-border)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "var(--mmp-surface)";
                  e.currentTarget.style.borderColor = "var(--mmp-border)";
                }}
              >
                <Send size={16} />
              </Button>
            </div>
          </div>
        </div>
        <div className="job-details-content">
          <div className="job-content">
            <div
              className={`job-card-headers ${!hasJobMeta ? "job-card-header--no-metas" : ""
                }`}
            >
              <div className="job-icon">
                <img
                  src={
                    PublicJobDetail?.profile_photo
                      ? PublicJobDetail.profile_photo.startsWith("http")
                        ? PublicJobDetail.profile_photo
                        : `${process.env.REACT_APP_API_BASE_URL}/uploads/job_photos/${PublicJobDetail.profile_photo}`
                      : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                        PublicJobDetail?.company?.name || "Company",
                      )}&background=${avatarBg}&color=fff&size=100&bold=true`
                  }
                  alt={PublicJobDetail?.company?.name || "Company"}
                  className="user-avatar"
                  onError={(e) => {
                    const target = e.target;
                    target.onerror = null;
                    target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                      PublicJobDetail?.company?.name || "Company",
                    )}&background=${avatarBg}&color=fff&size=100&bold=true`;
                  }}
                />
              </div>

              <div className="job-title-description">
                <div className="title-popular">
                  <div className="d-flex align-items-center justify-content-start gap-2 flex-wrap">
                    <div className="job-title">
                      {PublicJobDetail?.company?.name}
                    </div>
                    <div className="d-flex align-items-center gap-2 badge-container">
                      {PublicJobDetail?.source === "hospital" && (
                        <span
                          className={`badge ${PublicJobDetail?.apply_count > 5
                            ? "hospital-badge hospital-with-popular"
                            : "hospital-badge hospital-alone"
                            }`}
                        >
                          Hospital
                        </span>
                      )}
                    </div>
                  </div>
                  <span className="job-schedule">
                    <span>Posted {timeAgo(PublicJobDetail?.posted_date)}</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="content">
              <div className="job-type">{PublicJobDetail?.title}</div>
              <div className="job-location">
                <MapPin size={14} />
                {PublicJobDetail?.location?.city && PublicJobDetail?.location?.state
                  ? `${PublicJobDetail.location.city}, ${PublicJobDetail.location.state}`
                  : "Location not specified"}
              </div>
              <div className="job-salary">
                {formatSalary(PublicJobDetail?.salary)}
                <span className="job-period">/{PublicJobDetail?.salary?.period}</span>
              </div>
              <div className="posted-time">
                {PublicJobDetail?.apply_count} people clicked apply
                {Number(PublicJobDetail?.apply_count) > 5 && " · trending"}
              </div>
              <div className="job-desc">{PublicJobDetail?.description}</div>
              <div className="job-extra-meta">
                <div className="job-meta">
                  <div className="job-meta-left">
                    <div className="job-bonus">
                      <span>Bonus :</span>
                      <strong className="bonus-value">
                        {formatbonus(PublicJobDetail?.bonus)}
                      </strong>
                    </div>
                    <div className="job-bonus">
                      <span>Required License :</span>
                      <strong>{PublicJobDetail?.required_license_type}</strong>
                    </div>
                    <div className="job-bonus">
                      <span>Specialty :</span>
                      <strong className="specialty-value">
                        {PublicJobDetail?.specialty}
                      </strong>
                    </div>
                  </div>
                  <div className="job-meta-right">
                    <div className="job-bonus">
                      <span>Min Education :</span>
                      <strong>{PublicJobDetail?.min_education}</strong>
                    </div>
                    <div className="job-bonus">
                      <span>Min Years Experience :</span>
                      <strong>{PublicJobDetail?.min_years_experience}</strong>
                    </div>
                  </div>
                </div>
              </div>
              <div className="job-type-details-title">Job Type & Details</div>
              <div className="job-schedule tags">
                {PublicJobDetail?.work_model && (
                  <div className="tags">
                    <div className="tag-desc">{PublicJobDetail.work_model}</div>
                  </div>
                )}
                {PublicJobDetail?.shift_type && (
                  <div className="tags">
                    <div className="tag-desc">{PublicJobDetail.shift_type}</div>
                  </div>
                )}
                {PublicJobDetail?.job_type && (
                  <div className="tags">
                    <div className="tag-desc">{PublicJobDetail.job_type}</div>
                  </div>
                )}
              </div>
            </div>

            <div className="buttons pt-0">
              <Button
                className="w-100 btn btn-secondary"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();

                  if (!PublicJobDetail) return;

                  if (PublicJobDetail?.source === "hospital") {
                    navigate(`/job-detail/${PublicJobDetail.id}`);
                    return;
                  }

                  const url = getApplyUrl(PublicJobDetail?.application_url);

                  if (url && url !== "#") {
                    // apply_count is incremented only from the listing page card,
                    // not here — avoid double-counting when a user opens the detail
                    // page after clicking through from the listing.
                    window.open(url, "_blank", "noopener,noreferrer");
                  }
                }}
              >
                Apply Now
              </Button>
              {shareModal && (
                <div
                  className="modal-backdrop-overlay"
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                    backdropFilter: "blur(8px)",
                    WebkitBackdropFilter: "blur(8px)",
                    zIndex: 99998,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={closeShareModal}
                >
                  <div
                    className="modal-content-wrapper"
                    style={{
                      backgroundColor: "var(--mmp-surface)",
                      borderRadius: "12px",
                      maxWidth: "400px",
                      width: "90%",
                      boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
                      zIndex: 99999,
                      position: "relative",
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {/* Modal Header */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "12px",
                        borderBottom: "1px solid var(--mmp-border)",
                      }}
                    >
                      <h3
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          color: "var(--mmp-text-primary)",
                          margin: 0,
                          lineHeight: "24px",
                        }}
                      >
                        Share Job
                      </h3>
                      <button
                        onClick={closeShareModal}
                        style={{
                          background: "transparent",
                          border: "none",
                          cursor: "pointer",
                          padding: "4px",
                          borderRadius: "4px",
                          color: "var(--mmp-text-secondary)",
                          fontSize: "24px",
                          lineHeight: 1,
                        }}
                        aria-label="Close"
                      >
                        ×
                      </button>
                    </div>

                    {/* Modal Body */}
                    <div style={{ padding: "0" }}>
                      {/* Twitter */}
                      <div
                        onClick={() => shareToSocialMedia("twitter")}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          padding: "12px 24px",
                          cursor: "pointer",
                          borderBottom: "1px solid var(--mmp-border)",
                          transition: "background-color 0.2s ease",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "var(--mmp-hover-bg)")
                        }
                        onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          "transparent")
                        }
                      >
                        <div
                          style={{
                            width: "22px",
                            height: "22px",
                            backgroundColor: "#1da1f2",
                            borderRadius: "4px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                          }}
                        >
                          <FaXTwitter
                            size={14}
                            style={{
                              display: "block",
                              margin: "0 auto",
                            }}
                          />
                        </div>

                        <span style={{ fontSize: "14px", fontWeight: "500" }}>
                          Share on Twitter
                        </span>
                      </div>

                      {/* Facebook */}
                      <div
                        onClick={() => shareToSocialMedia("facebook")}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          padding: "12px 24px",
                          cursor: "pointer",
                          borderBottom: "1px solid var(--mmp-border)",
                          transition: "background-color 0.2s ease",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "var(--mmp-hover-bg)")
                        }
                        onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          "transparent")
                        }
                      >
                        <div
                          style={{
                            width: "22px",
                            height: "22px",
                            backgroundColor: "#1877f2",
                            borderRadius: "4px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                            fontSize: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          <FaFacebookF
                            size={14}
                            style={{
                              display: "block",
                              margin: "0 auto",
                            }}
                          />
                        </div>
                        <span style={{ fontSize: "14px", fontWeight: "500" }}>
                          Share on Facebook
                        </span>
                      </div>

                      {/* WhatsApp */}
                      <div
                        onClick={() => shareToSocialMedia("whatsapp")}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          padding: "12px 24px",
                          cursor: "pointer",
                          borderBottom: "1px solid var(--mmp-border)",
                          transition: "background-color 0.2s ease",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "var(--mmp-hover-bg)")
                        }
                        onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          "transparent")
                        }
                      >
                        <div
                          style={{
                            width: "22px",
                            height: "22px",
                            backgroundColor: "#25d366",
                            borderRadius: "4px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        >
                          <FaWhatsapp
                            size={14}
                            style={{
                              display: "block",
                              margin: "0 auto",
                            }}
                          />
                        </div>
                        <span style={{ fontSize: "14px", fontWeight: "500" }}>
                          Share on WhatsApp
                        </span>
                      </div>

                      {/* LinkedIn */}
                      <div
                        onClick={() => shareToSocialMedia("linkedin")}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          padding: "12px 24px",
                          cursor: "pointer",
                          borderBottom: "1px solid var(--mmp-border)",
                          transition: "background-color 0.2s ease",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "var(--mmp-hover-bg)")
                        }
                        onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          "transparent")
                        }
                      >
                        <div
                          style={{
                            width: "22px",
                            height: "22px",
                            backgroundColor: "#0077b5",
                            borderRadius: "4px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                            fontSize: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          <FaLinkedinIn
                            size={14}
                            style={{
                              display: "block",
                              margin: "0 auto",
                            }}
                          />
                        </div>
                        <span style={{ fontSize: "14px", fontWeight: "500" }}>
                          Share on LinkedIn
                        </span>
                      </div>

                      {/* Copy Link */}
                      <div
                        onClick={() => shareToSocialMedia("copy")}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          padding: "12px 24px",
                          cursor: "pointer",
                          transition: "background-color 0.2s ease",
                          borderBottomLeftRadius: "12px",
                          borderBottomRightRadius: "12px",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "var(--mmp-hover-bg)")
                        }
                        onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          "transparent")
                        }
                      >
                        <Copy
                          style={{
                            width: "20px",
                            height: "20px",
                            color: "var(--mmp-text-secondary)",
                          }}
                        />
                        <span style={{ fontSize: "14px", fontWeight: "500" }}>
                          Copy Link
                        </span>
                      </div>

                      {/* Share to Community */}
                      <div
                        // onClick={() => {
                        //   closeShareModal();
                        //   const jobContent = generateJobPostContent();
                        //   setPreFilledContent(jobContent);
                        //   setShowCreatePostModal(true);
                        // }}
                        onClick={() => {
                          closeShareModal();
                          const jobContent = generateJobPostContent();
                          if (!token) {
                            navigate("/login", {
                              state: {
                                redirectTo: "/community",
                                action: "OPEN_COMMUNITY_POST",
                                jobContent,
                              },
                            });

                            return;
                          }

                          setPreFilledContent(jobContent);
                          setShowCreatePostModal(true);
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          padding: "12px 24px",
                          cursor: "pointer",
                          borderTop: "1px solid var(--mmp-border)",
                          transition: "background-color 0.2s ease",
                          borderBottomLeftRadius: "12px",
                          borderBottomRightRadius: "12px",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "var(--mmp-accent-bg)")
                        }
                        onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          "transparent")
                        }
                      >
                        <Users
                          style={{
                            width: "20px",
                            height: "20px",
                            color: "var(--mmp-accent)",
                          }}
                        />
                        <span
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "var(--mmp-accent)",
                          }}
                        >
                          Share to Community
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Create Post Modal for sharing to community */}
              {/* <CreatePostModal
              show={showCreatePostModal}
              onHide={() => {
                setShowCreatePostModal(false);
                setPreFilledContent("");
              }}
              createPost={createPost}
              categories={categories}
              isLoading={categoriesLoading}
              initialCategory={
                jobListingCategory?.category_name || "Job Listing"
              }
              preFilledContent={preFilledContent}
              onpostSubmit={() => {}}
              onCategoryChange={() => {}}
            /> */}
              {showCreatePostModal && (
                <CreatePostModal
                  show={showCreatePostModal}
                  onHide={() => {
                    setShowCreatePostModal(false);
                    setPreFilledContent("");
                  }}
                  createPost={createPost}
                  categories={categories}
                  isLoading={categoriesLoading}
                  initialCategory={
                    jobListingCategory?.category_name || "Job Listing"
                  }
                  preFilledContent={preFilledContent}
                  onpostSubmit={() => { }}
                  onCategoryChange={() => { }}
                />
              )}
            </div>
          </div>
          <aside className="job-detail-jobs-rail">
            <aside className="quick-actions-panel" aria-label="Quick actions">
              <div className="quick-actions-title">QUICK ACTIONS</div>
              <button
                type="button"
                className="quick-action-row"
                onClick={() =>
                  navigate("/full-map", {
                    state: {
                      fromCityDetail: {
                        city: PublicJobDetail?.city_details?.city_details?.city || "",
                        state: PublicJobDetail?.city_details?.city_details?.state || "",
                        role: PublicJobDetail?.city_details?.city_details?.role || "",
                      },
                    },
                  })
                }
              >
                <span className="qa-icon qa-icon-map">
                  <FiMapPin />
                </span>
                <span className="qa-label">View on map</span>
              </button>
              <button
                type="button"
                className="quick-action-row"
                onClick={handleShareClick}
              >
                <span className="qa-icon">
                  <Send size={18} />
                </span>
                <span className="qa-label">Share</span>
              </button>
            </aside>
            <div className="search-details-content mt-3">
              {/* ── New city header ─────────────────────────────────────── */}
              <div className="city-header-new-design">
                <div className="header-text-info">
                  <div className="role-label">
                    {PublicJobDetail?.city_details?.city_details?.role?.toUpperCase()}
                  </div>
                  <h1 className="city-state-title">
                    {PublicJobDetail?.city_details?.city_details?.city},{" "}
                    {PublicJobDetail?.city_details?.city_details?.state}
                  </h1>
                </div>
                <div className="metrics-cards-container">
                  {(() => {
                    const appDisplay = String(
                      PublicJobDetail?.city_details?.city_details?.app_display || "",
                    ).trim().toLowerCase();
                    let crimeVariant = "is-default";
                    if (appDisplay === "moderate") crimeVariant = "is-moderate";
                    else if (appDisplay === "mild") crimeVariant = "is-mild";
                    else if (appDisplay === "severe") crimeVariant = "is-severe";
                    return (
                      <div className={`metric-card crime-card-new ${crimeVariant}`}>
                        <div className="icon-wrapper"><CrimeIcon /></div>
                        <div className="metric-content">
                          <div className="metric-label">Crime</div>
                          <div className="metric-value">
                            <span className="crime-level">
                              {PublicJobDetail?.city_details?.city_details?.app_display}
                            </span>
                            <span className="separator"> · </span>
                            <span className="crime-grade">
                              {PublicJobDetail?.city_details?.city_details?.overall_crime_grade}
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })()}
                  <div className="metric-card hospital-card-new">
                    <div className="icon-wrapper"><HospitalsIcon /></div>
                    <div className="metric-content">
                      <div className="metric-label">Hospitals</div>
                      <div className="metric-value">
                        <span className="hospital-count">
                          {PublicJobDetail?.city_details?.city_details?.hospital_count}
                        </span>
                        <span className="nearby-text"> nearby</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ── Jobs for this city ──────────────────────────────────── */}
              <Card className="city-all-contents mt-2 mb-2 pb-0">
                <Card.Body className="p-0">
                  <div className="job-card-collapsed">
                    <div
                      className="job-card-title"
                      onClick={() => setIsJobsExpanded(!isJobsExpanded)}
                    >
                      <span>
                        Jobs for this city{" "}
                        {jobs?.length > 0 && `(${jobs.length})`}
                      </span>
                      {isJobsExpanded ? (
                        <FiChevronUp
                          size={20}
                          style={{ transition: "transform 0.3s ease" }}
                        />
                      ) : (
                        <FiChevronDown
                          size={20}
                          style={{ transition: "transform 0.3s ease" }}
                        />
                      )}
                    </div>
                    <div className={`jobs-collapse-grid${isJobsExpanded ? "" : " is-closed"}`}>
                      <div className="jobs-collapse-inner">
                        {jobsLoading ? (
                          <div
                            className="jobs-loading-container"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "40px 20px",
                              width: "100%",
                            }}
                          >
                            <div
                              className="spinner-border text-primary"
                              role="status"
                              style={{ width: "40px", height: "40px" }}
                            >
                              <span className="visually-hidden">Loading...</span>
                            </div>
                            <p style={{ marginTop: "12px", color: "var(--mmp-text-secondary)", fontSize: "14px" }}>
                              Loading jobs...
                            </p>
                          </div>
                        ) : jobs?.length === 0 ? (
                          <p className="no-jobs">No Jobs available</p>
                        ) : (
                          <Row className="g-2 p-2">
                            {jobs.map((job) => (
                              <Col key={job.id} xl={6} lg={6} md={6} sm={12} className="search-job-card">
                                <Jobcards job={job} />
                              </Col>
                            ))}
                          </Row>
                        )}
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>

              {/* ── Salary & Housing ─────────────────────────────────────── */}
              <div className="salary-housing-section">
                <div className="salary-housing-top">
                  <div className="salary-housing-title">
                    Salary &amp; Housing — city average
                  </div>
                  <div className="salary-housing-subtitle">
                    Based on all{" "}
                    {PublicJobDetail?.city_details?.city_details?.role} roles in{" "}
                    {PublicJobDetail?.city_details?.city_details?.state}.
                  </div>
                </div>

                <div className="salary-home-grid">
                  <div className="salary-home-card">
                    <div className="card-label">Gross avg salary</div>
                    <div className="card-price">
                      $
                      {formatCompactPrice(
                        PublicJobDetail?.city_details?.city_details
                          ?.median_annual_salary,
                      )}
                    </div>
                    <div className="card-subtext">
                      $
                      {PublicJobDetail?.city_details?.city_details
                        ?.gross_hourly_salary
                        ? Number(
                          Number(
                            PublicJobDetail.city_details.city_details
                              .gross_hourly_salary,
                          ).toFixed(2),
                        ).toLocaleString("en-US")
                        : "0"}
                      /hr
                    </div>
                  </div>
                  <div className="salary-home-card">
                    <div className="card-label">
                      Typical Home Value for the Region
                    </div>
                    <div className="card-price">
                      $
                      {formatCompactPrice(
                        PublicJobDetail?.city_details?.city_details?.home_prices,
                      )}
                    </div>
                    <div className="card-subtext">single-family</div>
                  </div>
                </div>

                <div className="leftover-balance-card">
                  <div className="leftovers-title">LEFT OVER EACH MONTH</div>
                  <div className="leftover-grid">
                    <div className="leftover-item">
                      <div className="leftover-labels">Owning</div>
                      <div
                        className={`leftover-price ${Number(
                          PublicJobDetail?.city_details?.city_details
                            ?.left_over_annually_if_owning,
                        ) < 0
                          ? "negative"
                          : ""
                          }`}
                      >
                        $
                        {PublicJobDetail?.city_details?.city_details
                          ?.left_over_annually_if_owning
                          ? Number(
                            (
                              PublicJobDetail.city_details.city_details
                                .left_over_annually_if_owning / 12
                            ).toFixed(0),
                          ).toLocaleString("en-US")
                          : "0"}
                      </div>
                    </div>
                    <div className="leftover-item border-left">
                      <div className="leftover-labels">Renting</div>
                      <div
                        className={`leftover-price ${Number(
                          PublicJobDetail?.city_details?.city_details
                            ?.left_over_annually_if_renting,
                        ) < 0
                          ? "negative"
                          : ""
                          }`}
                      >
                        $
                        {PublicJobDetail?.city_details?.city_details
                          ?.left_over_annually_if_renting
                          ? Number(
                            (
                              PublicJobDetail.city_details.city_details
                                .left_over_annually_if_renting / 12
                            ).toFixed(0),
                          ).toLocaleString("en-US")
                          : "0"}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="money-month">
                  <div className="money-month-title">
                    Where your money goes each month
                  </div>
                  <div className="money-month-wrapper">
                    <div className="monthly-graph">
                      <div className="chart-wrap">
                        <Doughnut
                          data={chartPieData}
                          options={{
                            responsive: true,
                            maintainAspectRatio: false,
                            cutout: "50%",
                            plugins: {
                              legend: { display: false },
                              tooltip: { backgroundColor: "rgba(0,0,0,0.85)" },
                            },
                          }}
                        />
                      </div>
                    </div>
                    <div className="money-month-legend">
                      <div className="item">
                        <div className="left">
                          <span className="key taxes"></span>
                          <div className="text">
                            <div className="label">Income Tax</div>
                            <div className="percentage">
                              {formatPercent(
                                PublicJobDetail?.city_details?.pie_data?.[0]
                                  ?.text,
                              ).toFixed(0)}
                              %
                            </div>
                          </div>
                        </div>
                        <div className="price">
                          $
                          {PublicJobDetail?.city_details?.city_details
                            ?.monthly_tax_paid
                            ? Number(
                              Number(
                                PublicJobDetail.city_details.city_details
                                  .monthly_tax_paid,
                              ).toFixed(0),
                            ).toLocaleString("en-US")
                            : "0"}
                        </div>
                      </div>
                      <div className="item">
                        <div className="left">
                          <span className="key mortgage"></span>
                          <div className="text">
                            <div className="label">Mortgage</div>
                            <div className="percentage">
                              {formatPercent(
                                PublicJobDetail?.city_details?.pie_data?.[1]
                                  ?.text,
                              ).toFixed(0)}
                              %
                            </div>
                          </div>
                        </div>
                        <div className="price">
                          $
                          {PublicJobDetail?.city_details?.city_details
                            ?.monthly_mortgage_payment_7_065_apr
                            ? Number(
                              Number(
                                PublicJobDetail.city_details.city_details
                                  .monthly_mortgage_payment_7_065_apr,
                              ).toFixed(0),
                            ).toLocaleString("en-US")
                            : "0"}
                        </div>
                      </div>
                      <div className="item">
                        <div className="left">
                          <span className="key leftover"></span>
                          <div className="text">
                            <div className="label">Left Over</div>
                            <div className="percentage">
                              {Number(
                                PublicJobDetail?.city_details?.city_details
                                  ?.left_over_percent ?? 0,
                              ).toFixed(0)}
                              %
                            </div>
                          </div>
                        </div>
                        <div className="price">
                          $
                          {PublicJobDetail?.city_details?.city_details?.left_over
                            ? Number(
                              Number(
                                PublicJobDetail.city_details.city_details
                                  .left_over,
                              ).toFixed(0),
                            ).toLocaleString("en-US")
                            : "0"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ── Demographics, crime, schools, temperature (in card) ── */}
              <Card className="city-all-content mt-2">
                <Card.Body className="p-0">
                  <div className="city-details">
                    {/* old city-sub-details and subscription-details removed — replaced by new design above */}


                    {/* ── Demographics redesign ─────────────────────────── */}
                    <div className="demographics-content demographics-redesign-section">
                      <div className="custom-accordion p-0">
                        <div className="custom-accordion-item main-accordion">
                          <button
                            className="custom-accordion-button main-accordion-btn"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#demographics-main-${id}`}
                            aria-expanded="true"
                            aria-controls={`demographics-main-${id}`}
                          >
                            <span className="main-title">
                              {`${PublicJobDetail?.city_details?.city_details?.city || "City"} Demographics`}
                            </span>
                            <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
                              <path d="M1 6.5L6 1.5L11 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>

                          <div id={`demographics-main-${id}`} className="collapse show">
                            <div className="sub-accordions-wrapper">

                              {/* Education Levels */}
                              <div className="sub-accordion-item">
                                <button className="sub-accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={`#sub-demo-education-${id}`} aria-expanded="false">
                                  Education Levels
                                  <svg width="10" height="6" viewBox="0 0 12 8" fill="none">
                                    <path d="M1 6.5L6 1.5L11 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                </button>
                                <div id={`sub-demo-education-${id}`} className="collapse show sub-collapse">
                                  <div className="sub-accordion-body">
                                    {Object.entries(PublicJobDetail?.city_details?.education || {}).map(([label, value], index) => (
                                      <div className="demo-progress-row" key={index}>
                                        <div className="demo-progress-header">
                                          <span className="demo-label">{label}</span>
                                          <span className="demo-value fw-bold">{value}%</span>
                                        </div>
                                        <div className="demo-progress-bar-container">
                                          <div className="demo-progress-fill bg-blue-light" style={{ width: `${value}%` }}></div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>

                              {/* Racial Diversity */}
                              <div className="sub-accordion-item">
                                <button className="sub-accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={`#sub-demo-racial-${id}`} aria-expanded="false">
                                  Racial Diversity
                                  <svg width="10" height="6" viewBox="0 0 12 8" fill="none">
                                    <path d="M1 6.5L6 1.5L11 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                </button>
                                <div id={`sub-demo-racial-${id}`} className="collapse show sub-collapse">
                                  <div className="sub-accordion-body">
                                    {Object.entries(PublicJobDetail?.city_details?.radical_diversity || {}).map(([label, value], index) => (
                                      <div className="demo-progress-row" key={index}>
                                        <div className="demo-progress-header">
                                          <span className="demo-label">{label}</span>
                                          <span className="demo-value fw-bold">{value}%</span>
                                        </div>
                                        <div className="demo-progress-bar-container">
                                          <div className="demo-progress-fill bg-blue-dark" style={{ width: `${value}%` }}></div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>

                              {/* Income */}
                              <div className="sub-accordion-item">
                                <button className="sub-accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={`#sub-demo-income-${id}`} aria-expanded="false">
                                  Income
                                  <svg width="10" height="6" viewBox="0 0 12 8" fill="none">
                                    <path d="M1 6.5L6 1.5L11 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                </button>
                                <div id={`sub-demo-income-${id}`} className="collapse show sub-collapse">
                                  <div className="sub-accordion-body">
                                    {Object.entries(PublicJobDetail?.city_details?.income || {}).map(([label, value], index) => (
                                      <div className="demo-progress-row" key={index}>
                                        <div className="demo-progress-header">
                                          <span className="demo-label">{label}</span>
                                          <span className="demo-value fw-bold">{value}%</span>
                                        </div>
                                        <div className="demo-progress-bar-container">
                                          <div className="demo-progress-fill bg-green" style={{ width: `${value}%` }}></div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>

                              {/* Age */}
                              <div className="sub-accordion-item">
                                <button className="sub-accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={`#sub-demo-age-${id}`} aria-expanded="false">
                                  Age
                                  <svg width="10" height="6" viewBox="0 0 12 8" fill="none">
                                    <path d="M1 6.5L6 1.5L11 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                </button>
                                <div id={`sub-demo-age-${id}`} className="collapse show sub-collapse">
                                  <div className="sub-accordion-body">
                                    {Object.entries(PublicJobDetail?.city_details?.age || {}).map(([label, value], index) => (
                                      <div className="demo-progress-row" key={index}>
                                        <div className="demo-progress-header">
                                          <span className="demo-label">{label}</span>
                                          <span className="demo-value fw-bold">{value}%</span>
                                        </div>
                                        <div className="demo-progress-bar-container">
                                          <div className="demo-progress-fill bg-blue-light-alt" style={{ width: `${value}%` }}></div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>

                              {/* Crime */}
                              <div className="sub-accordion-item">
                                <button className="sub-accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={`#sub-demo-crime-${id}`} aria-expanded="false">
                                  Crime
                                  <svg width="10" height="6" viewBox="0 0 12 8" fill="none">
                                    <path d="M1 6.5L6 1.5L11 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                </button>
                                <div id={`sub-demo-crime-${id}`} className="collapse show sub-collapse">
                                  <div className="sub-accordion-body">
                                    <div className="info-row">
                                      <span className="label">Overall Crime Grade</span>
                                      <span className="value fw-bold text-warning">{grade || "N/A"}</span>
                                    </div>
                                    <div className="info-row">
                                      <span className="label">Violent Crime Grade</span>
                                      <span className="value fw-bold text-success">{violentGrade || "N/A"}</span>
                                    </div>
                                    <div className="info-row">
                                      <span className="label">Property Crime Grade</span>
                                      <span className="value fw-bold text-warning">{propertyGrade || "N/A"}</span>
                                    </div>
                                    <div className="info-row">
                                      <span className="label">Crime Score</span>
                                      <span className="value fw-bold">
                                        {PublicJobDetail?.city_details?.city_details?.crime_score || "N/A"}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Median Household Income */}
                              <div className="sub-accordion-item">
                                <button className="sub-accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={`#sub-demo-income-household-${id}`} aria-expanded="false">
                                  Median Household Income
                                  <svg width="10" height="6" viewBox="0 0 12 8" fill="none">
                                    <path d="M1 6.5L6 1.5L11 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                </button>
                                <div id={`sub-demo-income-household-${id}`} className="collapse show sub-collapse">
                                  <div className="sub-accordion-body">
                                    <div className="income-highlight">
                                      <div className="income-amount">
                                        $
                                        {PublicJobDetail?.city_details?.city_details?.net_annual_salary
                                          ? Number(Number(PublicJobDetail.city_details.city_details.net_annual_salary).toFixed(0)).toLocaleString("en-US")
                                          : "0"}
                                      </div>
                                      <div className="income-subtext">U.S. Census Bureau · 5-year ACS</div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Other */}
                              <div className="sub-accordion-item">
                                <button className="sub-accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={`#sub-demo-other-${id}`} aria-expanded="false">
                                  Other
                                  <svg width="10" height="6" viewBox="0 0 12 8" fill="none">
                                    <path d="M1 6.5L6 1.5L11 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                </button>
                                <div id={`sub-demo-other-${id}`} className="collapse show sub-collapse">
                                  <div className="sub-accordion-body">
                                    <div className="info-row">
                                      <span className="label">Zip</span>
                                      <span className="value fw-bold">
                                        {PublicJobDetail?.city_details?.city_details?.zip || "N/A"}
                                      </span>
                                    </div>
                                    <div className="info-row">
                                      <span className="label">Total population</span>
                                      <span className="value fw-bold">
                                        {PublicJobDetail?.city_details?.city_details?.total_population
                                          ? Number(PublicJobDetail.city_details.city_details.total_population).toLocaleString("en-US")
                                          : "N/A"}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ── Nursing License Sections (Registered Nurses only) ─ */}
                    {PublicJobDetail?.city_details?.city_details?.role === "Registered Nurses" && (
                      <>
                        {/* License Requirements */}
                        <div className={`license-req-desktop-card mb-1 mt-1 is-license-req-card ${isLicenseReqExpanded ? "is-open" : "is-closed"}`}>
                          <button
                            type="button"
                            className="license-req-card-title"
                            onClick={() => setIsLicenseReqExpanded((v) => !v)}
                            aria-expanded={isLicenseReqExpanded}
                          >
                            <span>License Requirements</span>
                            <svg className="license-req-chevron" width="12" height="8" viewBox="0 0 12 8" fill="none">
                              <path d="M1 6.5L6 1.5L11 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>
                          <Collapse in={isLicenseReqExpanded}>
                            <div>
                              <div className="license-req-card-body">
                                <div className="info-row">
                                  <span className="label">Compact state</span>
                                  <span className={`value fw-bold ${PublicJobDetail?.city_details?.nursing_license_req?.Compact_State?.toLowerCase().includes("no") ? "text-danger" : ""}`}>
                                    {PublicJobDetail?.city_details?.nursing_license_req?.Compact_State?.toLowerCase().includes("no") ? "No" : "Yes"}
                                  </span>
                                </div>
                                <div className="info-row">
                                  <span className="label">Initial license fee</span>
                                  <span className="value fw-bold">
                                    ${PublicJobDetail?.city_details?.nursing_license_req?.Initial_License_Fee || "N/A"}
                                  </span>
                                </div>
                                <div className="info-row">
                                  <span className="label">NCLEX registration fee</span>
                                  <span className="value fw-bold">
                                    ${PublicJobDetail?.city_details?.nursing_license_req?.NCLEX_Registration_Fee || "N/A"}
                                  </span>
                                </div>
                                <div className="info-row">
                                  <span className="label">Fingerprinting Requirements</span>
                                  <span className="value fw-bold">
                                    ${PublicJobDetail?.city_details?.nursing_license_req?.Fingerprinting_Requirements || "N/A"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </Collapse>
                        </div>

                        {/* CEUs */}
                        <div className={`license-req-desktop-card mb-1 ${isCeusExpanded ? "is-open" : "is-closed"}`}>
                          <button
                            type="button"
                            className="license-req-card-title"
                            onClick={() => setIsCeusExpanded((v) => !v)}
                            aria-expanded={isCeusExpanded}
                          >
                            <span>CEUs</span>
                            <svg className="license-req-chevron" width="12" height="8" viewBox="0 0 12 8" fill="none">
                              <path d="M1 6.5L6 1.5L11 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>
                          <Collapse in={isCeusExpanded}>
                            <div>
                              <div className="license-req-card-body">
                                {PublicJobDetail?.city_details?.nursing_license_req?.CEU_hours_required && (
                                  <div className="info-row">
                                    <span className="label">CEU hours required</span>
                                    <span className="value fw-bold">
                                      {PublicJobDetail.city_details.nursing_license_req.CEU_hours_required}
                                    </span>
                                  </div>
                                )}
                                {PublicJobDetail?.city_details?.nursing_license_req?.Renewal_period && (
                                  <div className="info-row">
                                    <span className="label">Renewal period</span>
                                    <span className="value fw-bold">
                                      {PublicJobDetail.city_details.nursing_license_req.Renewal_period}
                                    </span>
                                  </div>
                                )}
                                <div className="paragraph-text mt-2">
                                  {PublicJobDetail?.city_details?.nursing_license_req?.CEUs || "N/A"}
                                </div>
                              </div>
                            </div>
                          </Collapse>
                        </div>

                        {/* Special Requirements */}
                        <div className={`license-req-desktop-card mb-1 ${isSpecialReqExpanded ? "is-open" : "is-closed"}`}>
                          <button
                            type="button"
                            className="license-req-card-title"
                            onClick={() => setIsSpecialReqExpanded((v) => !v)}
                            aria-expanded={isSpecialReqExpanded}
                          >
                            <span>Special Requirements</span>
                            <svg className="license-req-chevron" width="12" height="8" viewBox="0 0 12 8" fill="none">
                              <path d="M1 6.5L6 1.5L11 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>
                          <Collapse in={isSpecialReqExpanded}>
                            <div>
                              <div className="license-req-card-body">
                                <div className="paragraph-text">
                                  {PublicJobDetail?.city_details?.nursing_license_req?.Special_Requirements || "N/A"}
                                </div>
                              </div>
                            </div>
                          </Collapse>
                        </div>

                        {/* Compact State */}
                        <div className={`license-req-desktop-card mb-1 ${isCompactStateExpanded ? "is-open" : "is-closed"}`}>
                          <button
                            type="button"
                            className="license-req-card-title"
                            onClick={() => setIsCompactStateExpanded((v) => !v)}
                            aria-expanded={isCompactStateExpanded}
                          >
                            <span>Compact State</span>
                            <svg className="license-req-chevron" width="12" height="8" viewBox="0 0 12 8" fill="none">
                              <path d="M1 6.5L6 1.5L11 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>
                          <Collapse in={isCompactStateExpanded}>
                            <div>
                              <div className="license-req-card-body">
                                {PublicJobDetail?.city_details?.nursing_license_req?.Compact_State?.toLowerCase().includes("no") ? (
                                  <div className="compact-state-alert">
                                    <span className="fw-bold text-danger">No</span>{" "}
                                    —{" "}
                                    {PublicJobDetail?.city_details?.city_details?.state || "This state"}{" "}
                                    does not participate in the Nurse Licensure Compact.
                                  </div>
                                ) : (
                                  <div className="paragraph-text">
                                    {PublicJobDetail?.city_details?.nursing_license_req?.Compact_State || "N/A"}
                                  </div>
                                )}
                              </div>
                            </div>
                          </Collapse>
                        </div>

                        {/* Important Considerations for Compact State Nurses */}
                        {PublicJobDetail?.city_details?.nursing_license_req?.Important_Considerations_for_Compact_State_Nurses && (
                          <div className={`license-req-desktop-card mb-1 ${isImportantConsiderationsExpanded ? "is-open" : "is-closed"}`}>
                            <button
                              type="button"
                              className="license-req-card-title"
                              onClick={() => setIsImportantConsiderationsExpanded((v) => !v)}
                              aria-expanded={isImportantConsiderationsExpanded}
                            >
                              <span>Important Considerations for Compact State Nurses</span>
                              <svg className="license-req-chevron" width="12" height="8" viewBox="0 0 12 8" fill="none">
                                <path d="M1 6.5L6 1.5L11 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              </svg>
                            </button>
                            <Collapse in={isImportantConsiderationsExpanded}>
                              <div>
                                <div className="license-req-card-body">
                                  <div
                                    className="paragraph-text"
                                    dangerouslySetInnerHTML={{
                                      __html: PublicJobDetail.city_details.nursing_license_req.Important_Considerations_for_Compact_State_Nurses || "N/A",
                                    }}
                                  />
                                </div>
                              </div>
                            </Collapse>
                          </div>
                        )}
                      </>
                    )}

                    {/* Nearby Schools */}
                    {/* ── Nearby Schools ─────────────────────────────────── */}
                    <div className="demographics-content nearby-schools-redesign-section">
                      <div className="custom-accordion p-0">
                        <div className="custom-accordion-item main-accordion">
                          <button
                            className="custom-accordion-button main-accordion-btn"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#nearby-schools-${id}`}
                            aria-expanded="true"
                          >
                            <span className="main-title">Nearby Schools</span>
                            <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
                              <path d="M1 6.5L6 1.5L11 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>

                          <div id={`nearby-schools-${id}`} className="collapse show">
                            <div className="accordion-body-content">
                              <div className="d-flex justify-content-end mb-2">
                                <Select
                                  onChange={(option) => setSelectedLevel(option)}
                                  aria-label="Select school level"
                                  defaultValue={{ value: "Elementary", label: "Elementary" }}
                                  menuPosition="fixed"
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      borderRadius: "8px",
                                      borderColor: "var(--mmp-border)",
                                      backgroundColor: "var(--mmp-surface)",
                                      minHeight: "36px",
                                      boxShadow: "none",
                                      "&:hover": { borderColor: "var(--mmp-text-secondary)" },
                                    }),
                                    singleValue: (base) => ({
                                      ...base,
                                      color: "var(--mmp-text-primary)",
                                    }),
                                    menu: (base) => ({
                                      ...base,
                                      borderRadius: "8px",
                                      marginTop: "4px",
                                      backgroundColor: "var(--mmp-surface)",
                                      zIndex: "1000",
                                    }),
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (base, state) => ({
                                      ...base,
                                      backgroundColor: state.isFocused ? "var(--mmp-hover-bg)" : "var(--mmp-surface)",
                                      color: "var(--mmp-text-primary)",
                                      cursor: "pointer",
                                    }),
                                  }}
                                  options={[
                                    { value: "Elementary", label: "Elementary" },
                                    { value: "Middle", label: "Middle" },
                                    { value: "High", label: "High" },
                                  ]}
                                  className="react-select-schools"
                                  classNamePrefix="react-select"
                                />
                              </div>

                              <div className="schools-list">
                                {schoolsLoading ? (
                                  <div className="text-center p-4">Loading schools...</div>
                                ) : schoolsResultsStore?.length > 0 ? (
                                  schoolsResultsStore.map((school) => {
                                    let scoreColorClass = "bg-green";
                                    if (school.review_score < 5) scoreColorClass = "bg-red";
                                    else if (school.review_score < 8) scoreColorClass = "bg-orange";
                                    return (
                                      <div
                                        className="school-card"
                                        key={school.id}
                                        onClick={() => handleSchoolClick(school)}
                                      >
                                        <div className={`school-score ${scoreColorClass}`}>
                                          {school.review_score}/10
                                        </div>
                                        <div className="school-details">
                                          <div className="school-name">{school.name}</div>
                                          {school.rating_band > 0 && (
                                            <div className="school-rating">
                                              <span className="star-icon">★</span>
                                              <span className="rating-val">{school.rating_band}</span>
                                              <span className="reviews-cnt">({school.review_count} reviews)</span>
                                            </div>
                                          )}
                                          <div className="school-meta">
                                            {school.type}, {school.level} · {school.student_count} students
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })
                                ) : (
                                  <div className="no-data text-center p-3 text-muted">
                                    No schools found for {selectedLevel?.label || "the selected"} level.
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {showModal && (
                        <Modal show={showModal} centered className="otp-modal custom-modal" size="md">
                          <Modal.Header>
                            <h5 className="modal-title">Error</h5>
                          </Modal.Header>
                          <Modal.Body className="pt-0">
                            <p className="text-center pb-3 m-0" style={{ fontSize: "1rem", fontWeight: "500" }}>
                              This school does not have a website. <br /> Please try again later.
                            </p>
                            <div className="d-flex justify-content-center pt-4">
                              <Button className="btn btn-primary w-30 text-center" onClick={() => setShowModal(false)}>
                                Close
                              </Button>
                            </div>
                          </Modal.Body>
                        </Modal>
                      )}
                    </div>

                    {/* ── Annual Temperature ──────────────────────────────── */}
                    <div className="demographics-content annual-temp-redesign-section">
                      <div className="custom-accordion p-0">
                        <div className="custom-accordion-item main-accordion">
                          <button
                            className="custom-accordion-button main-accordion-btn"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#annual-temp-${id}`}
                            aria-expanded="true"
                          >
                            <span className="main-title">Annual Temperature</span>
                            <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
                              <path d="M1 6.5L6 1.5L11 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>

                          <div id={`annual-temp-${id}`} className="collapse show">
                            <div className="accordion-body-content p-2">
                              <div className="annual-temp-chart">
                                <Line data={lineData} options={lineOptions} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </aside>
        </div>
      </div>
    </>
  );
};

export default JobDetail;
